module.exports = __webpack_public_path__ + "static/media/healthy-ageing-and-long-term-conditions.654e08e3.png";